import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const BannerSet = () => {
  // Banner data with titles, images, and navigation URLs
  const banners = [
    {
      id: 1,
      title: "Men Collection",
      image: "/image/24.png",
      url: "/category/men/All"
    },
    {
      id: 2,
      title: "Women Collection",
      image: "/image/22.png",
      url: "/category/women/All"
    },
    {
      id: 3,
      title: "Kids Collection",
      image: "/image/23.png",
      url: "/category/Kids/All"
    }
  ];


  const  navigate = useNavigate()

  // Handle banner click
  const handleBannerClick = (url) => {
    // For demo purposes, we'll show an alert
    // In real app, you'd use: window.location.href = url or React Router
    navigate(url)
    
    // Uncomment below for actual navigation:
    // window.location.href = url;
  };

  return (
    <div className="w-full px-4 py-8 max-sm:!px-1 max-sm:py-1">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl  text-center font-karla mb-8 text-gray-800 max-sm:mb-4">
          Popular Categories
        </h2>
        
        {/* Banner Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {banners.map((banner, index) => (
            <motion.div
              key={banner.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              className="cursor-pointer group"
              onClick={() => handleBannerClick(banner.url)}
            >
              <div className="relative overflow-hidden rounded-xl bg-white">
                {/* Banner Image */}
                <div className="relative h-auto max-h-[411px] sm:h-56 md:h-64 overflow-hidden">
                  <img
                    src={banner.image}
                    alt={banner.title}
                    className="w-full h-full object-cover transition-transform duration-300 "
                  />
                  
                  {/* Overlay */}
                  <div className="absolute inset-0  bg-opacity-20 group-hover:bg-opacity-30 transition-all duration-300" />
                  
                  {/* Title Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent">
                    <h3 className="text-white text-xl font-semibold">
                      {banner.title}
                    </h3>
                  </div>
                </div>
                
                {/* Click indicator */}
                <motion.div
                  className="absolute top-4 right-4 bg-white bg-opacity-90 rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  whileHover={{ scale: 1.1 }}
                >
                  <svg 
                    className="w-5 h-5 text-gray-700" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M13 7l5 5m0 0l-5 5m5-5H6" 
                    />
                  </svg>
                </motion.div>
              </div>
            </motion.div>
          ))}
        </div>
        
      </div>
    </div>
  );
};

export default BannerSet;